import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Copy, CheckCircle2, HeartHandshake } from 'lucide-react';
export function Donate() {
  const [copied, setCopied] = useState(false);
  const accountNumber = '5080135317';
  const handleCopy = () => {
    navigator.clipboard.writeText(accountNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <section id="donate" className="py-20 md:py-32 bg-gold text-midnight overflow-hidden relative" data-id="element-97">
      {/* Decorative background text */}
      <div className="absolute -top-20 -right-20 w-96 h-96 bg-white/20 rounded-full blur-3xl pointer-events-none" data-id="element-98" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-midnight text-ivory rounded-[2rem] md:rounded-[3rem] p-6 sm:p-8 md:p-16 relative shadow-2xl" data-id="element-100">
          {/* Rotated Badge */}
          <div className="absolute -top-4 right-4 md:-top-6 md:-right-10 bg-white text-midnight font-bold px-4 md:px-6 py-2 md:py-3 rounded-full rotate-12 shadow-xl border-2 md:border-4 border-midnight text-[10px] md:text-sm tracking-widest uppercase flex items-center gap-1.5 md:gap-2 whitespace-nowrap" data-id="element-101">
            <HeartHandshake className="w-3 h-3 md:w-4 md:h-4 text-gold" data-id="element-102" />
            Partner With Us
          </div>

          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center relative z-10" data-id="element-103">
            <div data-id="element-104">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-xs font-bold tracking-widest uppercase mb-6 md:mb-8 text-gold" data-id="element-105">
                Partnership
              </div>
              <h3 className="text-4xl sm:text-5xl md:text-6xl font-display font-bold tracking-tighter mb-6" data-id="element-106">
                Support the <br data-id="element-107" />
                <span className="font-serif italic font-medium text-gold" data-id="element-108">
                  Vision
                </span>
              </h3>
              <p className="text-base md:text-lg text-ivory/80 font-medium leading-relaxed mb-8" data-id="element-109">
                Your generous donations help us continue our outreaches,
                retreats, and missions to raise Kingdom Giants and support those
                in need across communities.
              </p>
              <p className="text-sm font-bold tracking-widest uppercase text-gold" data-id="element-110">
                Every gift fuels a soul.
              </p>
            </div>

            <div className="bg-white text-midnight p-6 sm:p-8 md:p-10 rounded-[1.5rem] md:rounded-[2rem] shadow-xl md:rotate-1" data-id="element-111">
              <div className="space-y-6 md:space-y-8" data-id="element-112">
                <div data-id="element-113">
                  <p className="text-xs font-bold uppercase tracking-widest text-charcoal/50 mb-2" data-id="element-114">
                    Bank
                  </p>
                  <p className="text-xl md:text-2xl font-display font-bold" data-id="element-115">
                    Fidelity Bank
                  </p>
                </div>
                <div data-id="element-116">
                  <p className="text-xs font-bold uppercase tracking-widest text-charcoal/50 mb-2" data-id="element-117">
                    Account Name
                  </p>
                  <p className="text-lg md:text-xl font-display font-bold break-words" data-id="element-118">
                    CAMP DAVID PRAYER TEAM
                  </p>
                </div>
                <div data-id="element-119">
                  <p className="text-xs font-bold uppercase tracking-widest text-charcoal/50 mb-2" data-id="element-120">
                    Account Number
                  </p>
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between bg-midnight/5 p-3 sm:p-2 sm:pr-2 sm:pl-6 rounded-2xl sm:rounded-full mt-2 border-2 border-midnight/10 gap-3 sm:gap-2" data-id="element-121">
                    <span className="text-2xl md:text-3xl font-display font-black tracking-wider text-midnight text-center sm:text-left break-all" data-id="element-122">
                      {accountNumber}
                    </span>
                    <button onClick={handleCopy} className="bg-midnight text-ivory px-5 md:px-6 py-3 rounded-full font-bold text-sm tracking-wide hover:bg-gold hover:text-midnight transition-colors flex items-center justify-center gap-2 active:scale-95 w-full sm:w-auto shrink-0" aria-label="Copy account number" data-id="element-123">
                      {copied ? <>
                          <CheckCircle2 className="w-4 h-4" data-id="element-124" />
                          Copied
                        </> : <>
                          <Copy className="w-4 h-4" data-id="element-125" />
                          Copy
                        </>}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}